export const implementationProofs = [
    {
        id: 'audit_hash_chain',
        title: 'Audit hash chain with per-company sequence',
        sourcePath: 'packages/db/src/pg/audit.ts',
        reference: 'audit_events + previous_hash + event_hash + sequence_number',
    },
    {
        id: 'queue_audit_integrity',
        title: 'Queue worker integrity handling for audit events',
        sourcePath: 'packages/queue/src/index.ts',
        reference: 'handleAuditEvent maintains hash-chain continuity',
    },
    {
        id: 'payment_event_traceability',
        title: 'Payment event creation and linkage to operations',
        sourcePath: 'packages/db/src/pg/finance.ts',
        reference: 'createPaymentEvent + payment_abonos + eventIdentityKey',
    },
    {
        id: 'voucher_ocr_traceability',
        title: 'Voucher OCR processing with status timeline',
        sourcePath: 'packages/queue/src/index.ts',
        reference: 'payment_voucher_ocr queue flow and status updates',
    },
    {
        id: 'tenant_isolation_sql_scope',
        title: 'Tenant isolation by company-scoped SQL policy',
        sourcePath: 'AGENTS.md',
        reference: 'Non-negotiable company_id scoping rules for queries',
    },
    {
        id: 'encryption_and_security_controls',
        title: 'Encryption and API security controls',
        sourcePath: 'SECURITY.md',
        reference: 'encryption at rest/in transit, JWT, RBAC, rate limiting',
    },
    {
        id: 'backup_recovery_controls',
        title: 'Backup and recovery controls',
        sourcePath: 'docs/backup-recovery.md',
        reference: 'backup, encryption, retention and recovery playbook',
    },
    {
        id: 'sperant_translator_pipeline',
        title: 'Sperant translator PostgreSQL migration pipeline',
        sourcePath: 'packages/sperant-translator/README.md',
        reference: '5-step Sperant XLS -> PostgreSQL pipeline for real migrations',
    },
    {
        id: 'sperant_migration_consistency',
        title: 'Post-migration database consistency verification',
        sourcePath: 'packages/sperant-translator/src/pipeline/Step5RunDbConsistency.ts',
        reference: 'Step5RunDbConsistency validates migrated data integrity after promotion',
    },
    {
        id: 'sperant_file_contracts',
        title: 'Sperant export contract detection and schema coverage',
        sourcePath: 'packages/sperant-translator/src/extract/SperantFileContracts.ts',
        reference: 'Sperant file contracts define recognized exports and expected structure',
    },
];
export const implementationProofById = implementationProofs.reduce((accumulator, proof) => {
    accumulator[proof.id] = proof;
    return accumulator;
}, {});
